import { createGetAPI } from '@cuemath/rest-api';

import { BASE_URL } from '../../constants/api';

const { useGet: useTeacherRetentionHistoryGet } = createGetAPI({
  getURL: teacherId => `${BASE_URL}/teachers/retention-history/${teacherId}`,
});

export { useTeacherRetentionHistoryGet };
